import Image from "next/image";

function getInitials(name) {
  const cleaned = name.replace(/^Dr\.\s+/i, "").split(",")[0].trim();
  const parts = cleaned.split(/\s+/).filter(Boolean);
  const first = parts[0]?.[0] || "";
  const last = parts.length > 1 ? parts[parts.length - 1][0] : "";
  return (first + last).toUpperCase();
}

export default function EmployeeAvatar({ employee, size = 112, className = "" }) {
  if (employee.headshot) {
    return (
      <Image
        src={employee.headshot}
        alt={employee.name}
        width={size}
        height={size}
        className={`rounded-full object-cover ring-4 ring-white shadow-md outline outline-1 outline-[#d9eadb] ${className}`}
      />
    );
  }

  return (
    <div
      className={`flex items-center justify-center rounded-full bg-gradient-to-br from-[#9fce8a] to-[#01A6DE] text-white font-bold ring-4 ring-white shadow-md outline outline-1 outline-[#d9eadb] ${className}`}
      style={{ width: size, height: size, fontSize: size * 0.32 }}
      aria-hidden="true"
    >
      {getInitials(employee.name)}
    </div>
  );
}
